import {i18n} from 'src/i18n';

/** Pasar a false para incluir las columnas del parte Blumar en la exportación de todos los tenants. */
const hideBlumarStuffForOthers = true;
const BLUMAR_SSO_TENANT_ID = '62a8b6dd2323505723b7e92b';
const BLUMAR_EXPORTER_FIELD_NAMES = new Set([
  'contactPhone',
  'directManagerPosition',
  'propertyDamage',
  'workPerformed',
  'atSea',
  'causingAgent',
  'injuryType',
  'narratorName',
  'narratorRole',
  'causalEffect',
  'causalProblem',
  'causalCause1',
  'causalCause2',
  'causalCause3',
  'investigationConclusion',
  'entrevistasRows',
  'incidentWeekday',
  'accionesSubestandar',
  'condicionesSubestandar',
  'tipoAccidente',
  'medidasControlRows',
]);

const exporterFields = [
  {
    name: 'division',
    label: 'División',
  },
  {
    name: 'incidentCode',
    label: i18n('entities.incident.fields.incidentCode'),
  },
  {
    name: 'employeeName',
    label: 'Nombre',
  },
  {
    name: 'registrationNumber',
    label: 'RUT',
  },
  {
    name: 'email',
    label: 'Email',
  },
  {
    name: 'codeSheet',
    label: 'Code Sheet',
  },
  {
    name: 'withLostDays',
    label: 'CTP/STP',
  },
  {
    name: 'incidentDate',
    label: 'Fecha Incidente',
  },
  {
    name: 'reportDate',
    label: 'Fecha Reporte',
  },
  {
    name: 'submissionDate',
    label: 'Fecha Presentación',
  },
  {
    name: 'dateFrom',
    label: 'Inicio Reposo',
  },
  {
    name: 'dateTo',
    label: 'Fin Reposo',
  },
  {
    name: 'nombreJefatura',
    label: 'Nombre Jefatura',
  },
  {
    name: 'rutJefatura',
    label: 'RUT Jefatura',
  },
  {
    name: 'ubicacionIncidente1',
    label: 'Ubicación Incidente 1',
  },
  {
    name: 'ubicacionIncidente2',
    label: 'Ubicación Incidente 2',
  },
  {
    name: 'ubicacionIncidente3',
    label: 'Ubicación Incidente 3',
  },
  {
    name: 'ubicacionIncidente4',
    label: 'Ubicación Incidente 4',
  },
  {
    name: 'ubicacionIncidente5',
    label: 'Ubicación Incidente 5',
  },
  {
    name: 'centroTrabajo',
    label: 'Centro de Trabajo',
  },
  {
    name: 'area1',
    label: 'Area 1',
  },
  {
    name: 'area2',
    label: 'Area 2',
  },
  {
    name: 'area3',
    label: 'Area 3',
  },
  {
    name: 'finalClassification',
    label: i18n('entities.incident.fields.finalClassification'),
  },
  {
    name: 'causaInmediata1',
    label: 'Causa Inmediata 1',
  },
  {
    name: 'causaInmediata2',
    label: 'Causa Inmediata 2',
  },
  {
    name: 'causaInmediata3',
    label: 'Causa Inmediata 3',
  },
  {
    name: 'causaBasica1',
    label: 'Causa Básica 1',
  },
  {
    name: 'causaBasica2',
    label: 'Causa Básica 2',
  },
  {
    name: 'causaBasica3',
    label: 'Causa Básica 3',
  },
  {
    name: 'medidasControl',
    label: 'Medidas de Control',
  },
  {
    name: 'testigos',
    label: 'Testigos',
  },
  {
    name: 'testigosRows',
    label: 'Tabla Testigos',
  },
  {
    name: 'tipoRiesgo',
    label: 'Tipo de Riesgo',
  },
  {
    name: 'familiaRiesgo',
    label: 'Familia de Riesgo',
  },
  {
    name: 'riesgo',
    label: 'Riesgo',
  },
  {
    name: 'codigoRiesgo',
    label: 'Código de Riesgo',
  },
  {
    name: 'injuredZone',
    label: 'Zona Lesionada',
  },
  {
    name: 'injuredZoneSpecific',
    label: 'Zona Lesionada Específica',
  },
  {
    name: 'gender',
    label: 'Género',
  },
  {
    name: 'birthDate',
    label: 'Fecha de Nacimiento',
  },
  {
    name: 'ageYears',
    label: 'Edad (Años)',
  },
  {
    name: 'nationality',
    label: 'Nacionalidad',
  },
  {
    name: 'jobPosition',
    label: 'Cargo',
  },
  {
    name: 'contractType',
    label: 'Tipo de Contrato',
  },
  {
    name: 'contractStartDate',
    label: 'Inicio Contrato',
  },
  {
    name: 'workExperienceYears',
    label: 'Antigüedad Cargo (Años)',
  },
  {
    name: 'workExperienceMonths',
    label: 'Antigüedad Cargo (Meses)',
  },
  {
    name: 'workExperienceDays',
    label: 'Antigüedad Cargo (Días)',
  },
  {
    name: 'companyStartDate',
    label: 'Inicio Empresa',
  },
  {
    name: 'companyExperienceYears',
    label: 'Antigüedad Empresa (Años)',
  },
  {
    name: 'companyExperienceMonths',
    label: 'Antigüedad Empresa (Meses)',
  },
  {
    name: 'companyExperienceDays',
    label: 'Antigüedad Empresa (Días)',
  },
  {
    name: 'horaSiniestro',
    label: 'Hora Siniestro',
  },
  {
    name: 'incidentLocationName',
    label: 'Lugar donde ocurrió',
  },
  {
    name: 'incidentStatus',
    label: 'Estado actual',
  },
  {
    name: 'isInvestigating',
    label: 'En Investigación',
  },
  {
    name: 'incidentDescription',
    label: i18n('entities.incident.fields.incidentDescription'),
  },
  // { name: 'internoSuceso', label: '...' }, // deprecado, usar severity
  {
    name: 'severity',
    label: i18n('entities.incident.fields.severity'),
  },
  {
    name: 'narrativeAccount',
    label: 'Relato de los Hechos',
  },
  {
    name: 'contactPhone',
    label: i18n('entities.incident.fields.contactPhone'),
  },
  {
    name: 'directManagerPosition',
    label: i18n('entities.incident.fields.directManagerPosition'),
  },
  {
    name: 'propertyDamage',
    label: i18n('entities.incident.fields.propertyDamage'),
  },
  {
    name: 'workPerformed',
    label: i18n('entities.incident.fields.workPerformed'),
  },
  {
    name: 'atSea',
    label: i18n('entities.incident.fields.atSea'),
  },
  {
    name: 'causingAgent',
    label: i18n('entities.incident.fields.causingAgent'),
  },
  {
    name: 'injuryType',
    label: i18n('entities.incident.fields.injuryType'),
  },
  {
    name: 'narratorName',
    label: i18n('entities.incident.fields.narratorName'),
  },
  {
    name: 'narratorRole',
    label: i18n('entities.incident.fields.narratorRole'),
  },
  {
    name: 'causalEffect',
    label: i18n('entities.incident.fields.causalEffect'),
  },
  {
    name: 'causalProblem',
    label: i18n('entities.incident.fields.causalProblem'),
  },
  {
    name: 'causalCause1',
    label: i18n('entities.incident.fields.causalCause1'),
  },
  {
    name: 'causalCause2',
    label: i18n('entities.incident.fields.causalCause2'),
  },
  {
    name: 'causalCause3',
    label: i18n('entities.incident.fields.causalCause3'),
  },
  {
    name: 'investigationConclusion',
    label: i18n('entities.incident.fields.investigationConclusion'),
  },
  {
    name: 'entrevistasRows',
    label: i18n('entities.incident.fields.entrevistas'),
  },
  {
    name: 'incidentWeekday',
    label: i18n('entities.incident.fields.incidentWeekday'),
  },
  {
    name: 'tipoAccidente',
    label: i18n('entities.incident.fields.tipoAccidente'),
  },
  {
    name: 'accionesSubestandar',
    label: i18n('entities.incident.fields.accionesSubestandar'),
  },
  {
    name: 'condicionesSubestandar',
    label: i18n('entities.incident.fields.condicionesSubestandar'),
  },
  {
    name: 'medidasControlRows',
    label: i18n('entities.incident.fields.medidasDeControl'),
  },
];

export function incidentExporterFieldsForTenant(tenantId?: string | null) {
  if (!hideBlumarStuffForOthers || String(tenantId || '') === BLUMAR_SSO_TENANT_ID) {
    return exporterFields;
  }
  return exporterFields.filter((field) => !BLUMAR_EXPORTER_FIELD_NAMES.has(field.name));
}

export default exporterFields;
